import styled from 'styled-components'
import {
  FONT_SIZE,
  COLOR,
  Z_INDEXS
} from '../../themes'
import { colorThemeSelector } from '../../helpers'
const Style = styled.div`
  z-index: ${Z_INDEXS.LV_MAX};
  width: 100%;
  height: 100%;
  background-color: #000000AA;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  -webkit-user-select: none;
  -moz-user-select: none;
  -khtml-user-select: none;
  -ms-user-select: none;
  user-select: none;
  .DatePicker {
    background-color: white;
    width: 300px;
    height: 400px;
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
    padding: 12px;
    border-radius: 3px;
  }
  .DatePicker hr{
    position: relative;
    top: auto;
    left: auto;
    margin: 3px 0;
    padding: 0;
    width: none;
    align-self: stretch;
    border: 2px solid ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    border-radius: 6px;
    background-color: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
  }
  .DatePicker hr.lightLine{
    border: 1px solid ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
  }
  .calendarButton {
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
  }
  .MonthnYear {
    color: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    width: 100%;
    height: 50px;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-around;
    align-items: center;
  }
  .calendarButton button {
    font-size: ${FONT_SIZE.MMN};
    cursor: pointer;
  }
  .calendarButton h3,
  .MonthnYear h1 {
    text-transform: uppercase;
    padding: 0;
    margin: 0;
  }
  .MonthnYear h1 {
    font-size: ${FONT_SIZE.SM};
  }
  .calendarButton > button,
  .MonthnYear button {
    flex: 1;
    padding: 6px;
    margin: 0;
    border: 2px solid white;
    transition: color 30ms ease-out, background-color 30ms ease-out, border 30ms ease-out;
    background-color: white;
    border-radius: 3px;
    color: ${COLOR.BLACK_1};
    outline: 0px;
  }
  .calendarButton > button {
    flex: 0;
    min-width: 64px;
    max-width: 64px;
    height: 30px;
    line-height: 1em;
    margin-left: 3px;
    color: white;
  }
  .MonthnYear button:hover {
    background-color: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    color: ${({ colorTheme }) => colorThemeSelector(colorTheme).FONT_COLOR.TEXT || COLOR.BLACK_1};
    cursor: pointer;
  }
  .MonthnYear:active button:hover {
    background-color: transparent;
    color: ${COLOR.GOLD_1};
  }
  .MonthnYear:active button:active,
  .MonthnYear button:active {
    color: ${COLOR.BLACK_1};
    background-color: ${COLOR.Sky_1};
  }
  .calendarButton > button.saveButton {
    background-color: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    border-radius: 4px;
    color: ${({ colorTheme }) => colorThemeSelector(colorTheme).FONT_COLOR.TEXT || COLOR.BLACK_1}
  }
  .calendarButton > button.closeButton {
    background-color: black;
    border-radius: 4px;
  }
  .calendarButton > button.saveButton:hover {
    border: 2px solid ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    border-radius: 3px;
  }
  .calendarButton > button.closeButton:hover {
    border: 2px solid black;
    border-radius: 3px;
  }
  .calendarButton > button.saveButton:active {
    color: ${({ colorTheme }) => colorThemeSelector(colorTheme).FONT_COLOR.TEXT || COLOR.BLACK_1};
    background-color: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
  }
  .calendarButton > button.closeButton:active {
    border: 2px solid ${COLOR.GRAY_3};
    background-color: ${COLOR.GRAY_3};
  }
  .calendarButton > button.saveButton:disabled {
    background-color: ${COLOR.GOLD_1};
  }
  .calendarField {
    flex: 1;
    position: relative;
    width: 100%;
    height: 100%;
  }
  .calendarField > section {
    position: absolute;
    opacity: 1;
    color: black;
    overflow: hidden;
    width: 0;
    height: 0;
    transition: opacity 100ms ease-out, width 1ms ease-out 100ms, height 1ms ease-out 100ms;
    width: 100%;
    height: 100%;
    flex: 1;
    background-color: white;
    text-align: center;
    display: grid;
    grid-auto-flow: row;
  }
  .calendarField section.calendarDay {
    grid-template-columns: repeat(7, 36px);
    grid-template-rows: repeat(7, 36px);
    justify-content: center;
    align-items: stretch;
    grid-gap: 6px;
  }
  .calendarField section.calendarMonth {
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(4, 63px);
    justify-content: center;
    align-items: stretch;
    grid-gap: 6px 10px;
  }
  .calendarField section.calendarYear {
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(7, 36px);
    justify-content: center;
    align-items: stretch;
    grid-gap: 6px 10px;
    overflow-y: scroll;
    -webkit-user-select: none;
    -moz-user-select: none;
    -khtml-user-select: none;
    -ms-user-select: none;
    user-select: none;
    scrollbar-width: none;
  }
  .calendarField section::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
  .calendarField section > button {
    outline: 0;
    border: 1px solid transparent;
    background: transparent;
    padding: 0;
    line-height: 1em;
    position: relative;
    transition: color 30ms ease-out, background-color 30ms ease-out, border 30ms ease-out;
  }
  .calendarField section > button > h3 {
    padding: 0;
    margin: 0;
  }
  .calendarField section.calendarYear > button {
    border-radius: 3px;
    margin: 0;
  }
  .calendarField section.calendarMonth > button {
    border-radius: 3px;
    margin: 6px 0;
  }
  .calendarField section.calendarDay > button {
    border-radius: 50%;
    margin: 0;
  }
  .calendarField section > button.currentCar:not([disabled]):hover {
    border: 1px solid ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    color: black;
    background: transparent;
  }
  .calendarField section:active > button.currentCar:not([disabled]):hover {
    border: 1px solid white;
    background: white;
    color: black;
  }
  .calendarField section:active > button.currentCar:not([disabled]):active,
  .calendarField section > button.currentCar:not([disabled]):active {
    border: 1px solid ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    background: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    color: ${({ colorTheme }) => colorThemeSelector(colorTheme).FONT_COLOR.TEXT || COLOR.BLACK_1};
  }
  .calendarField section:active > button.selectDate:not([disabled]):hover,
  .calendarField section > button.selectDate:not([disabled]):hover,
  .calendarField section > button.selectDate:not([disabled]) {
    border: 1px solid ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    background: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    color: ${({ colorTheme }) => colorThemeSelector(colorTheme).FONT_COLOR.TEXT || COLOR.BLACK_1};
  }
  .calendarField section > button.selectDate:not([disabled]):hover {
    border: 1px solid ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
  }
  .calendarField section > button:disabled {
    color: ${COLOR.GRAY_3};
    cursor: not-allowed;
  }
  .calendarField section > button.prevCar,
  .calendarField section > button.nextCar {
    color: ${COLOR.GRAY_6};
  }
  .calendarField section > button.today::before {
    content: '';
    position: absolute;
    left: calc(50% - 3px);
    top: 70%;
    margin: 3px 0 0 0;
    font-size: ${FONT_SIZE.XXXL};
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
  }
  .calendarField .calendarHeader {
    border-bottom: 2px solid ${COLOR.GRAY_3};
    width: 100%;
    margin: auto;
  }
  .calendarField section > button.prevCar,
  .calendarField section > button.nextCar {
    background-color: transparent;
    border: 0px solid transparent;
  }
  .slide-in {
    animation-timing-function: ease-out;
    animation-duration: 100ms;
    animation-name: slide-in;
    animation-iteration-count: 1;
    animation-direction: normal;
  }
  @keyframes slide-in {
    0% {
      max-height: 0%;
      opacity: 0.5;
    }
    100% {
      max-height: 100%;
      opacity: 1;
    }
  }
  .fade-out {
    animation-timing-function: ease-in;
    animation-duration: 100ms;
    animation-name: fade-out;
    animation-iteration-count: 1;
    animation-direction: normal;
  }
  @keyframes fade-out {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
  .fade-in {
    animation-timing-function: ease-out;
    animation-duration: 100ms;
    animation-name: fade-in;
    animation-iteration-count: 1;
    animation-direction: normal;
  }
  @keyframes fade-in {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  .jump-in {
    animation-timing-function: ease-out;
    animation-duration: 800ms;
    animation-name: jump-in;
    animation-iteration-count: 1;
    animation-direction: normal;
  }
  @keyframes jump-in {
    0% {
      max-height: 0vh;
      max-width: 0vw;
      top: 50%;
      left: 50%;
      opacity: 0;
    }
    100% {
      max-height: 100vh;
      max-width: 100vw;
      top: 0;
      left: 0;
      opacity: 1;
    }
  }
  .holiday{
    color: ${COLOR.GRAY_3};
  }
`

export default Style
